import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { forgetBookingLocation } from '../lib/bookingLocation';

/* ============================================================
   BOOKING LOCATION SCOPE

   The club a member picks on Book is theirs for as long as they
   are booking, and no longer. This watches the route and drops the
   choice the moment they are somewhere else — Home, Shop, My Game,
   Profile, a session's details, anywhere.

   WHY A WATCHER AND NOT A HANDLER. The first version of this
   forgot the club on a tab-bar tap, which is only one of the ways
   out: confirming a booking sends the member to Home with
   `navigate('/home', { replace: true })`, the system back gesture
   routes without touching any control of ours, and a deep link
   never passes through the shell at all. Each of those left a
   secondary club selected, so the next booking silently started at
   the wrong one — the failure this is here to prevent. Watching
   where the member IS covers every route out, including the ones
   nobody has written yet.

   THE FLOW IS THREE ROUTES. Booking type and slot picking are the
   flow proper; `/waiver` is inside it too — the slot picker sends
   members there mid-booking and takes them straight back, and
   forgetting the club on the way would undo the choice in the
   middle of acting on it. `/booking-success` is deliberately NOT
   in the set: by then the booking exists and the journey is over,
   so the next one starts at the member's own club.

   Mounted once, next to the router's other invisible listeners.
   ============================================================ */

const IN_FLOW = ['/booking-type', '/booking-slots', '/waiver'];

export function BookingLocationScope() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!IN_FLOW.some((route) => pathname.startsWith(route))) {
      forgetBookingLocation();
    }
  }, [pathname]);

  return null;
}
